/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageStateEnum } from './messageStateEnum';
import { RolloutActionType } from './rolloutActionType';


export interface NotificationResultSummary { 
    type?: RolloutActionType;
    state?: MessageStateEnum;
}
export namespace NotificationResultSummary {
}


